import "react-app-polyfill/stable";
import { initI18N } from "i18n";
import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import TagManager from "react-gtm-module";
import { Spinner, TranslationContextProvider } from "component-library";
import { QueryClient, QueryClientProvider } from "react-query";
import { LaunchDarklyProvider, initSentry } from "shared-services";

import "./index.css";

import { config } from "./config/common";
import { ApplicationContextProvider } from "./context/ApplicationContext";
import { CastingContextProvider } from "./context/CastingApplicationContext";
import { UserContextProvider } from "./context/UserContext";
import { YPApplicationContextProvider } from "./context/YPApplicationContext";
import AppRoutes from "./Routes";

initSentry(null, "joining-pages");
initI18N(["joining"]);

TagManager.initialize({
  gtmId: config.gtm.gtmId,
  events: {
    conversion: "conversion",
  },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.render(
  <Suspense
    fallback={
      <div className="flex items-center justify-center w-screen h-screen">
        <Spinner />
      </div>
    }
  >
    <React.StrictMode>
      <UserContextProvider>
        <LaunchDarklyProvider thisUser={null}>
          <ApplicationContextProvider>
            <YPApplicationContextProvider>
              <CastingContextProvider>
                <QueryClientProvider client={queryClient}>
                  <TranslationContextProvider>
                    <AppRoutes />
                  </TranslationContextProvider>
                </QueryClientProvider>
              </CastingContextProvider>
            </YPApplicationContextProvider>
          </ApplicationContextProvider>
        </LaunchDarklyProvider>
      </UserContextProvider>
    </React.StrictMode>
  </Suspense>,
  document.getElementById("root")
);
